if (!customElements.get('product-bundel')) {
    customElements.define('product-bundel', class ProductForm extends HTMLElement {
        constructor() {
            super();

            this.form = this.querySelector('form');
            this.form.querySelector('.fbtVr').disabled = false;
            this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
            this.cart = document.querySelector('cart-drawer');
            this.submitButton = this.querySelector('.upsellAddToCart');
            if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        onSubmitHandler(evt) {
            evt.preventDefault();
            if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

            this.handleErrorMessage();

            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.classList.add('loading');
            this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];

            const formData = new FormData(this.form);
            if (this.cart) {
                formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
                formData.append('sections_url', window.location.pathname);
                this.cart.setActiveElement(document.activeElement);
            }
            config.body = formData;

            fetch(`${routes.cart_add_url}`, config)
                .then((response) => response.json())
                .then((response) => {
                    if (response.status) {
                        this.handleErrorMessage(response.description);

                        const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                        if (!soldOutMessage) return;
                        this.submitButton.setAttribute('aria-disabled', true);
                        this.submitButton.querySelector('span').classList.add('hidden');
                        soldOutMessage.classList.remove('hidden');
                        this.error = true;
                        return;
                    } else if (!this.cart) {
                        window.location = window.routes.cart_url;
                        return;
                    }

                    this.error = false;
                    this.cart.renderContents(response);
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally(() => {
                    this.submitButton.classList.remove('loading');
                    if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                    if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                    this.querySelector('.loading-overlay__spinner').classList.add('hidden');
                    if (typeof freeShippMsg === 'function') freeShippMsg();
                });
        }

        handleErrorMessage(errorMessage = false) {
            this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.pform-error-wrap');
            if (!this.errorMessageWrapper) return;
            this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.pform-error-msg');

            this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

            if (errorMessage) {
                this.errorMessage.textContent = errorMessage;
            }
        }
    });
}

/*
 * Fills the "Frequently Bought Together" bundle with Shopify's native product
 * recommendations (Search & Discovery). The current product is rendered server
 * side; the recommended items are fetched from routes.product_recommendations_url
 * (complementary intent, optional fallback to related) and appended to the bundle.
 */
if (!customElements.get('upsell-recommendations')) {
    customElements.define('upsell-recommendations', class UpsellRecommendations extends HTMLElement {
        connectedCallback() {
            if (this.loading) return;
            this.loading = true;

            this.load(this.dataset.url)
                .then((loaded) => {
                    if (!loaded && this.dataset.fallbackUrl) return this.load(this.dataset.fallbackUrl);
                    return loaded;
                })
                .then((loaded) => {
                    if (loaded) {
                        this.whenThemeReady(() => this.reveal());
                    } else {
                        this.remove();
                    }
                })
                .catch((e) => {
                    console.error(e);
                    this.remove();
                });
        }

        load(url) {
            return fetch(url)
                .then((response) => response.text())
                .then((text) => {
                    const html = document.createElement('div');
                    html.innerHTML = text;
                    const imgs = html.querySelector('[data-fbt-imgs]');
                    const rows = html.querySelector('[data-fbt-rows]');
                    if (!imgs || !rows || !rows.querySelector('.fbtCol')) return false;

                    this.querySelector('[data-fbt-img-list]').append(...imgs.children);
                    this.querySelector('[data-fbt-row-list]').append(...rows.children);
                    return true;
                });
        }

        whenThemeReady(fn, tries = 0) {
            if (window.jQuery && window.theme && theme.Currency) return fn();
            if (tries > 100) return fn();
            setTimeout(() => this.whenThemeReady(fn, tries + 1), 50);
        }

        reveal() {
            this.recalcTotal();
            this.classList.add('is-loaded');
            if (typeof ajaxFbt === 'function') ajaxFbt(this);
        }

        recalcTotal() {
            let total = 0;
            this.querySelectorAll('.fbtCol.data.checked .fbtVr').forEach((select) => {
                const option = select.options[select.selectedIndex];
                if (option) total += parseInt(option.dataset.price, 10) || 0;
            });
            const priceEl = this.querySelector('.fbtPrice');
            if (!priceEl) return;
            priceEl.setAttribute('data-pr', total);
            priceEl.setAttribute('data-total', total);
            priceEl.innerHTML = theme.Currency.formatMoney(total, theme.moneyFormat);
        }
    });
}

ajaxFbt = function (root) {
    var $root = $(root || document);
    if ($root.find('.fbtCheck').length == 0) return;

    var time,
        tt_price = $root.find('.fbtPrice'),
        price_old;

    $root.find('.fbtCol .fblbl').off('click.fbt').on('click.fbt', function (e) {
        clearTimeout(time);
        var frm = $(this).closest('.fbtCol'),
            imgCol = frm.data('img'),
            fbtVr = frm.find('.fbtVr');

        time = setTimeout(function () {
            if (frm.find('.fbtCheck').is(':checked')){
                frm.addClass('checked');
                $root.find(imgCol).addClass('checked');
                fbtVr.prop('disabled', false);
                fbt_update(fbtVr, true);
            } else {
                frm.removeClass('checked');
                $root.find(imgCol).removeClass('checked');
                fbtVr.prop('disabled', true);
                fbt_update(fbtVr, false);
            }
        }, 100);
    });
    $root.find('.fbtVr').off('mousedown.fbt click.fbt change.fbt').on('mousedown.fbt click.fbt', function (e) {
        /* Store the current value on focus and on change */
        var _this = $(this),
            optCked = _this.find('option:checked');
        price_old = optCked.data('price');

    }).on('change.fbt', function(e){
        var _this = $(this),
            fbtCol = _this.closest('.fbtCol'),
            imgCol = fbtCol.data('img'),
            fbtPrice = fbtCol.find('.price'),
            optCked = _this.find('option:checked'),
            price = optCked.data('price'),
            img = optCked.data('img');
        if (img != undefined) {
            $root.find(imgCol).find('.gitem-img').css("background-image", "url(" + img + ")")
        }

        var b = price_old - price;
        fbtPrice.html(theme.Currency.formatMoney(price, theme.moneyFormat));

        /* update total */
        tt_update(b, false);

    });

    function fbt_update(fbtVr, bl) {
        var optCked = fbtVr.find('option:checked'),
            price = optCked.attr('data-price');
        tt_update(price, bl);
    };

    function tt_update(price, bl) {
        if (bl) {
            var price = parseInt(tt_price.attr('data-pr')) + parseInt(price);
        } else {
            var price = parseInt(tt_price.attr('data-pr')) - parseInt(price);
        }
        tt_price.attr('data-pr', price);
        tt_price.html(theme.Currency.formatMoney(price, theme.moneyFormat));
    };
};
